module.exports = __webpack_public_path__ + "static/media/SR MPC(20-06-2026).3abcf6ec.xlsx";